import { render, staticRenderFns } from "./tianbaoxiangqing.vue?vue&type=template&id=7614ffb0&scoped=true"
import script from "./tianbaoxiangqing.vue?vue&type=script&lang=js"
export * from "./tianbaoxiangqing.vue?vue&type=script&lang=js"
import style0 from "./tianbaoxiangqing.vue?vue&type=style&index=0&id=7614ffb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7614ffb0",
  null
  
)

export default component.exports